import { render, staticRenderFns } from "./record.vue?vue&type=template&id=36501a78&scoped=true&"
import script from "./record.vue?vue&type=script&lang=js&"
export * from "./record.vue?vue&type=script&lang=js&"
import style0 from "./record.vue?vue&type=style&index=0&id=36501a78&lang=scss&scoped=true&"
import style1 from "./record.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36501a78",
  null
  
)

component.options.__file = "record.vue"
export default component.exports